import Layout from "@app/(components)/Layout";
import ErrorPageContent from "@app/(components)/common/ErrorPageContent";

export default function Custom404() {
  return (
    <Layout background="white" footerColor="primary">
      <ErrorPageContent
        title="Page not found"
        body="Sorry, we can't find the page you're looking for."
        showHomeLink
      />
    </Layout>
  );
}

export async function getStaticProps() {
  return { props: { global: {} } };
}
